import { Scale } from "lucide-react";
import CerfaPrepConsole from "@/components/memo/CerfaPrepConsole";

export default function AudienceOuvertureSection({ dossierId }) {
    return (
        <section data-testid="audience-ouverture-section" className="space-y-6">
            <div className="flex items-center gap-3">
                <div className="h-9 w-9 rounded-full bg-primary flex items-center justify-center"><Scale className="h-4 w-4 text-primary-foreground" strokeWidth={1.75} /></div>
                <div>
                    <h3 className="font-display text-xl text-foreground">2 - Audience d&apos;Ouverture · Cockpit Formulaire DCP</h3>
                    <p className="text-xs text-muted-foreground">Cockpit de données de la Déclaration de Cessation des Paiements — aucune rédaction IA. Complétez la stratégie, l&apos;actif/passif retraité et les annexes, puis générez le Formulaire DCP officiel.</p>
                </div>
            </div>
            <CerfaPrepConsole dossierId={dossierId} />
        </section>
    );
}
